import React from 'react';
import { Button, CircularProgress, makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const SpinnerAdornment = spinnerProps => {
  const classes = useStyles();
  return (
    <CircularProgress className={classes.loader} size={20} {...spinnerProps} />
  );
};

const RtvButton = ({
  variant,
  className,
  children,
  loading = false,
  spinnerProps = {},
  ...props
}) => {
  const classes = useStyles();
  return (
    <Button
      variant="contained"
      className={clsx([classes.buttonRoot, classes[variant], className])}
      {...props}
    >
      {children}
      {loading && <SpinnerAdornment {...spinnerProps} />}
    </Button>
  );
};

const useStyles = makeStyles(theme => ({
  buttonRoot: {
    fontWeight: 500,
    position: 'relative'
  },
  primary: {
    backgroundColor: theme.palette.yellow.main,
    border: `1.5px solid transparent`,
    '&:disabled': {
      border: `1.5px solid transparent`
    },
    '&:hover': {
      backgroundColor: theme.palette.yellow.dark
    }
  },
  secondary: {
    backgroundColor: '#fff',
    border: `1.5px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: '#fff'
    }
  },
  rtvRed: {
    backgroundColor: theme.palette.primary.main,
    borderColor: `1.5px solid transparent`,
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark
    }
  },
  loader: {
    position: 'absolute',
    zIndex: 1,
    color: '#000'
  }
}));

export default RtvButton;
